import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'shortNumber' })
export class ShortNumberPipe implements PipeTransform {
    transform(num: number): number | string {
        if (!num) {
            return '';
        }

        if (num > 999) {
            return '999+';
        }
        return num;
    }
}
